import { useEffect, useRef, useState, type FunctionComponent, } from "react";
import { chainInfo, } from "./helpers";
import { ChooseChainDD, } from "./ChooseChainDD";
import { Chevron, } from "../../assets/icons";
import { useChainId } from "wagmi";

export declare type ChooseChainELProps = {

};


export const ChooseChainEL: FunctionComponent<ChooseChainELProps> = ({

}) => {


	const [ rect, setRect, ] = useState<DOMRect | null>(null);
	const over = useRef(false);
	const [, setForceRender] = useState<any>();
	const choosing = useRef(false);

	const compRef = useRef<HTMLDivElement>(null);
	const activeChainId = useChainId();

	const classes = () => [
		`select-chain-el`,
		choosing.current ? "active" : "inactive",
	].join(" ");

	const onClientResize = () => {
		if (compRef.current) {
			setRect(compRef.current.getBoundingClientRect());
			return;
		}
	};

	useEffect(() => {
		if (compRef.current) {
			setRect(compRef.current.getBoundingClientRect());
			const { visualViewport, } = window;
			if (visualViewport) {
				visualViewport.addEventListener("resize", onClientResize);
				window.addEventListener("scroll", onClientResize);
				window.addEventListener("mousedown", onMouseDownOut);
				return () => {
					visualViewport.removeEventListener("resize", onClientResize);
					window.addEventListener("scroll", onClientResize);
					window.removeEventListener("mousedown", onMouseDownOut);
				}
			}
			else {
				window.addEventListener("resize", onClientResize);
				window.addEventListener("scroll", onClientResize);
				window.addEventListener("mousedown", onMouseDownOut);
				return () => {
					window.addEventListener("resize", onClientResize);
					window.addEventListener("scroll", onClientResize);
					window.removeEventListener("mousedown", onMouseDownOut);
				}
			}
		}
	}, []);

	const onActivate = ( ) => {
		choosing.current = !choosing.current;
		setForceRender(Object.entries(choosing.current));
	}

	const onMouseDownOut = ( ) => {
		if( choosing.current && !over.current ) {
			choosing.current = false;
			setForceRender(Object.entries(choosing.current));
		}
	}

	const onMouseEnter = ( ) => {
		if( !over.current ) {
			over.current = true;
			setForceRender(Object.entries(choosing.current));
		}
	}

	const onMouseLeave = ( ) => {
		if( over.current ) {
			over.current = false;
			setForceRender(Object.entries(choosing.current));
		}
	}


	if (activeChainId) {
		const info = chainInfo(activeChainId as any)
		return (
			<div className={classes()} onClick={onActivate} ref={compRef} onMouseOver={onMouseEnter} onMouseOut={onMouseLeave}>
				<div className="chain-badge" >
					<div className="chain-icon" style={{ backgroundImage: `url(${info.icon})`, }} />
				</div>
				<Chevron />
				{
					choosing.current &&
					rect &&
					<ChooseChainDD rect={rect} onMouseDownOut={onMouseDownOut} />
				}
			</div>
		);
	}
	throw new Error("ConnectionManager::ChooseChainEL was rendered without a valid active chain Id");
}
